// extracted by mini-css-extract-plugin
export default {"html":"vp_cE7rz"};